export enum RouteStartCondition {
    JourneyStart,
    DepartFromAnyVisit,
    DepartStartLocation
}

